import { ChequeTerceroRechazoRecargo, ChequeTerceroRechazoRequest } from '../services/tesoreriaService';

export const TIPOS_ARTICULO_RECARGO = 'FIN,SER';

export const esTipoRecargoPermitido = (tipo?: string | null): boolean => {
  const t = (tipo ?? '').trim().toUpperCase();
  return t === 'FIN' || t === 'SER';
};

export const recargoEsValido = (r: ChequeTerceroRechazoRecargo): boolean =>
  r.codigoArticulo.trim().length > 0 &&
  r.descripcion.trim().length > 0 &&
  Number(r.importe) > 0;

export const filtrarRecargosValidos = (
  recargos: ChequeTerceroRechazoRecargo[]
): ChequeTerceroRechazoRecargo[] => recargos.filter(recargoEsValido);

export const debeResolverCodigoArticulo = (codigo: string): boolean => {
  const trimmed = codigo.trim();
  return trimmed.length > 0 && !trimmed.includes(' ');
};

export interface BuildRechazoRequestOptions {
  guardarSinCae?: boolean;
  generarNdProveedor?: boolean;
  idCompania?: string;
}

export const buildRechazoRequest = (
  recargos: ChequeTerceroRechazoRecargo[],
  options: BuildRechazoRequestOptions = {}
): ChequeTerceroRechazoRequest => ({
  recargos: filtrarRecargosValidos(recargos),
  generarNdProveedor: Boolean(options.generarNdProveedor),
  emitirConCaePrimero: !options.guardarSinCae,
  guardarSinCae: Boolean(options.guardarSinCae),
  idCompania: options.idCompania,
});

export const tieneRecargosIncompletos = (recargos: ChequeTerceroRechazoRecargo[]): boolean =>
  recargos.some((r) => !recargoEsValido(r) && (r.codigoArticulo.trim() || Number(r.importe) > 0));
